<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="cip">
<p class="cip"><a class="page" id="pvi"></a>NeW YORK UNIVERSITY PRESS</p>
<p class="cip">New York and London</p>
<p class="cip"><a class="url" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></p>
<p class="cipf">© 2016 by New York University</p>
<p class="cip">All rights reserved</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Hardesty, Jared Ross, author.</p>
<p class="cip">Title: Unfreedom : slavery and dependence in eighteenth-century Boston / Jared Ross Hardesty.</p>
<p class="cip">Description: New York : New York University Press, 2016. | Series: Early American places | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2015043166 | ISBN 9781479816149 (cl : alk. paper)</p>
<p class="cip">Subjects: LCSH: Slavery—Massachusetts—Boston—History—18th century. | Slaves—Massachusetts—Boston—History—18th century. | Indentured servants—Massachusetts—Boston—History—18th century. | Boston (Mass.)—History—Colonial period, ca. 1600–1775. | Boston (Mass.)—Social conditions—18th century.</p>
<p class="cip">Classification: LCC F73.4.H37 2016 | DDC 306.3/620974461—dc23</p>
<p class="cip">LC record available at http://lccn.loc.gov/2015043166</p>
<p class="cipf">References to Internet Web sites (URLs) were accurate at the time of writing. Neither the author nor New York University Press is responsible for URLs that may have expired or changed since the manuscript was prepared.</p>
<p class="cipf">Manufactured in the United States of America</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hardesty-0004.vue?70d99681